<template>
  <div class="thankyouPage page">
    
    <div class="columns">
      <div class="column">
        <div>
          <h1>Aktivierung</h1>
          <p>Hallo ,</p>
          <p>vielen Dank, Ihr Account ist nun aktiviert.</p>
          <p>Sie können sich einloggen und die App in vollen Umfang benutzen.</p>
          <p><router-link :to="{ name: 'LoginPage'}" class="button">Zum Login</router-link></p>
          
          <p>Falls Sie Fragen haben zur Klinker App oder deren Bedienung, bitte melden Sie sich.<br>
            Wir helfen gern, freuen uns über jedes Feedback und jeden Verbesserungsvorschlag.</p>
          <p>Viel Erfolg!<br>
            Ihr Team von köhler.</p>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  export default {
    name: 'ActivationPage',
    data: function(){
      return {
         }
    },
    created: function(){
    },
    mounted: function(){},
    computed: {

    }
}
</script>
<style>
</style>